import { render, staticRenderFns } from "./PostulantsDashboard.vue?vue&type=template&id=67e0730c&"
import script from "./PostulantsDashboard.vue?vue&type=script&lang=js&"
export * from "./PostulantsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports